import {
  INITIALIZE_AGREEMENT_USER_INFO,
  INITIALIZE_USER_INFO,
  RECEIVE_USER_INFO,
  SET_IS_USER,
  SET_LOGGED_IN,
  SET_TOS_VERSION,
} from './actions';

export const initialState = {
  data: [],
  loggedIn: false,
  isUser: false,
  agreementUserInfo: false,
  tosVersion: '',
};

const reducer = (state, action) => {
  let { type, payload } = action;
  switch (type) {
    case INITIALIZE_USER_INFO:
      return {
        ...state,
        data: payload.userInfo,
      };
    case SET_LOGGED_IN:
      return {
        ...state,
        loggedIn: payload.loggedIn,
      };
    case SET_IS_USER:
      return {
        ...state,
        isUser: payload.isUser,
      };
    case INITIALIZE_AGREEMENT_USER_INFO:
      return {
        ...state,
        agreementUserInfo: payload.agreementUserInfo,
      };
    //todo: error handling
    case RECEIVE_USER_INFO:
      return {
        ...state,
        data: payload.data,
      };
    case SET_TOS_VERSION:
      return {
        ...state,
        tosVersion: payload.data,
      };
    default:
      return state;
  }
};

export { reducer };
